<div class="blog-action">
  <h1>{{ newsId ? "Edit" : "Add" }} News</h1>
  <div class="blog-action__content">
    <form [formGroup]="newsForm" (submit)="onSubmit()">
      <div class="blog-action__row flex-wrap">
        <div class="blog-action__col">
          <div class="input-field">
            <label>Title <span>*</span></label>
            <input
              type="text"
              formControlName="title"
              placeholder="Enter Title"
              inNoWhitespace
            />
            <span
              *ngIf="newsForm.get('title')?.errors?.['required']&&(newsForm.get('title')?.dirty||newsForm.get('title')?.touched)"
            >
              Title is required
            </span>
          </div>
          <div class="blog-action__date input-field">
            <label> Publish Date Time<span>*</span></label>
            <input type="datetime-local" formControlName="publishedAt" />
          </div>
        </div>
        <div class="blog-action__col">
          <div class="blog-action__upload flex-col">
            <label>Upload Image <span>*</span></label>
            <div class="blog-action__file flex-col align-center justify-center">
              <app-upload-image
                (uploadEnd)="onImageUploadEnd($event)"
                (uploadStart)="onImageUploadStart()"
                [previewUrl]="imageUrl"
                (removeImage)="removeImage()"
              ></app-upload-image>
            </div>
            <div
              class="is-error"
              *ngIf="newsForm.get('img')?.errors?.['required']&&(newsForm.get('img')?.dirty||newsForm.get('img')?.touched)"
            >
              Image is required
            </div>
          </div>
        </div>
      </div>
      <div class="blog-action__editor">
        <app-custom-editor
          label="News Content"
          controlName="description"
          [form]="newsForm"
        ></app-custom-editor>
        <div
          class="blog-action__error"
          *ngIf="newsForm.get('description')?.errors?.['required']&&(newsForm.get('description')?.dirty||newsForm.get('description')?.touched)"
        >
          Content is required
        </div>
      </div>

      <div class="blog-action__footer flex justify-end">
        <app-button customClass="outline" (action)="cancel()" label="cancel">
        </app-button>
        <app-button
          [isDisabled]="isLoading || initialLoading || imageUploading"
          type="submit"
          label="Submit"
        >
          <app-button-loader
            *ngIf="isLoading"
            postfixContent
          ></app-button-loader>
        </app-button>
      </div>
    </form>
  </div>
</div>
